import client from "./client";

export default {

    async getNotificationTypes(filters) {
        return client.parseResponse(client.parseResponse(await client.get('/notification-types', filters)));
    },
    async createNotificationType(data) {
        return client.parseResponse(await client.post('/notification-types', data))
    },
    async editNotificationType(data) {
        return client.parseResponse(await client.put('/notification-types/' + data.id, data))
    },
    async deleteNotificationType(data) {
        return client.parseResponse(await client.delete('/notification-types/' + data.id))
    }
}
